import { Button, Flex, Stack } from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { FormSection } from '../../../../forms/FormSection'
import { VehicleForm } from '../../Step1/forms/VehicleForm'
import type { Step1FormValues } from '../Step1'

export const Vehicle = ({
  onSave,
  isLoading,
  isContracted
}: {
  onSave: () => Promise<any>,
  isLoading: boolean
  isContracted: boolean
}) => {
  const {
    formState: { dirtyFields }
  } = useFormContext<Step1FormValues>()

  // isDirty z RHF funguje nejak zvlastne a obcas i kdyz je dirtyField prazdne, tak ukazuje, ze je formular zmenen
  const isDirty = Object.keys(dirtyFields).length > 0

  return (
    <FormSection
      number={2}
      sectionTitle="Vozidlo"
      footer={!onSave ? undefined :
        <Stack direction='column' w='100%'>
          <Flex sx={{ w: '100%', justifyContent: 'center' }} gap={4}>
            {isContracted && isDirty &&
              <Button
                type="button"
                variant="solid"
                isLoading={isLoading}
                // colorScheme="green"
                onClick={onSave}
              >
                Uložit
              </Button>
            }

            {!isContracted && isDirty &&
              <Button
                type="button"
                variant="solid"
                isLoading={isLoading}
                colorScheme="green"
                onClick={onSave}
              >
                Sjednat pojištění
              </Button>
            }
          </Flex>
        </Stack>}
    >
      <VehicleForm />
    </FormSection>
  )
}